import React from 'react';
import { Card } from 'semantic-ui-react';
import OcrNodesTable from '../../components/OcrNodesTable';

const OcrNode = () => {
  return (
    <div className='dashboard-container'>
      <Card fluid className='chart-card'>
        <Card.Content>
          <Card.Header className='header'>算力节点</Card.Header>
          <p style={{ color: '#8a919f', marginTop: 0 }}>
            OCR 算力节点（本地算力节点 / 服务器 CPU 版 OCR 服务）建档与令牌管理。节点以
            「注册 → 心跳 → 接取任务 → 提交结果」方式接入（<code>/api/v1/node/*</code>
            ），节点按任务里的客户侧公网地址直接下载简历文件（网关不下载、不落盘）。
            节点令牌仅展示一次，请交付节点方写入配置；服务器 CPU OCR 与本地算力节点同价。
          </p>
          <OcrNodesTable />
        </Card.Content>
      </Card>
    </div>
  );
};

export default OcrNode;
